import { ROLE_TYPE } from './types';
import useRequireRoles from './useRequireRoles';
import useRoles from './useRoles';

export const useIsDebug = () => useRoles(ROLE_TYPE.DEBUG);
export const useRequireDebug = () => useRequireRoles(ROLE_TYPE.DEBUG);
